import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { GridCell } from '@fuww/library/src/Grid';
import LinkAndAnchor from '../LinkAndAnchor';

const listItemWrapperPropertyTypes = {
  route: PropTypes.string.isRequired,
  params: PropTypes.shape({}).isRequired,
  useRouter: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

type ListItemWrapperProperties = InferProps<
  typeof listItemWrapperPropertyTypes
>;

const ListItemWrapper = ({
  route,
  params: parameters,
  useRouter,
  children,
}: ListItemWrapperProperties) => (
  <GridCell
    sm={6}
    lg={3}
    padding="16px"
  >
    <LinkAndAnchor
      route={route}
      params={parameters}
      useRouter={useRouter ?? true}
    >
      { children }
    </LinkAndAnchor>
  </GridCell>
);

ListItemWrapper.propTypes = listItemWrapperPropertyTypes;

export default ListItemWrapper;
